export default "__VITE_ASSET__B6h_Vst9__"